module.exports = __webpack_public_path__ + "static/media/things-to-know-about-startup-business.78d24824.md";